import {Table} from './table';

export class Database {

    pId:number;
    qId:number;
    tId:number;
    terminalType:number;

    tables:Table[] = [];


    constructor(json:any) {


        this.pId = json.pId;
        this.qId = json.qId;
        this.tId = json.tId;
        this.terminalType = json.terminalType;

        if(json.tables !=null) {
            for(let i =0;i<json.tables.length;i++) {
                this.tables.push(new Table(json.tables[i]));
            }

        }
    }

    getTableIndex(tableName:string):number {
        let index = -1;

        for(const tab of this.tables) {
            if(tab.name === tableName) {
                break;
            }
            index++;
        }

        return index;
    }
}
